export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://3430-39-62-153-120.ngrok-free.app/";

export const API_PATHS = {
  auth: {
    login: "/api/auth/login",
    register: "/api/auth/register",
    me: "/api/auth/me",
    users: "/api/auth/users",
  },
  tickets: {
    submit: "/api/ticket",
  },
  articles: {
    base: "/api/articles",
  },
  announcements: {
    publicBase: "/api/announcements",
    filters: "/api/announcements/filters",
    adminBase: "/api/admin/announcements",
  },
};

export const SUBMIT_TICKET_PATH = API_PATHS.tickets.submit;
